import { Toaster, TooltipProvider } from "@companyos/ui";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { Api } from "../api/client";
import { UploadTray } from "../features/work/upload-tray";
import { ErrorPage, NotFoundPage } from "../pages/status-pages";
import { OfflineBanner } from "../shell/offline-banner";
import { ShellStateProvider } from "../shell/shell-state";

export type RouterContext = { queryClient: QueryClient; api: Api };

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <main
      id="main"
      className="flex min-h-svh items-center justify-center bg-background p-4 text-foreground"
    >
      {children}
    </main>
  );
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: function Root() {
    return (
      <Toaster>
        <TooltipProvider>
          <ShellStateProvider>
            <Outlet />
          </ShellStateProvider>
          {/* HARDEN-pwa: no network, on every screen (sign-in included). */}
          <OfflineBanner />
          {/* UPLOAD-NEVER-BLOCKS: uploads keep going (and show) wherever the person goes. */}
          <UploadTray />
        </TooltipProvider>
      </Toaster>
    );
  },
  notFoundComponent: () => (
    <Centered>
      <NotFoundPage />
    </Centered>
  ),
  errorComponent: ({ error, reset }) => (
    <Centered>
      <ErrorPage error={error} reset={reset} />
    </Centered>
  ),
});
